import { render } from "./MainImageSectionView.vue?vue&type=template&id=38f6361e&scoped=true"
import script from "./MainImageSectionView.vue?vue&type=script&lang=js"
export * from "./MainImageSectionView.vue?vue&type=script&lang=js"

import "./MainImageSectionView.vue?vue&type=style&index=0&id=38f6361e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38f6361e"]])

export default __exports__